// import { IResourceComponentsProps } from "@refinedev/core";
// import { MuiShowInferencer } from "@refinedev/inferencer/mui";

// export const ClientShow: React.FC<IResourceComponentsProps> = () => {
//   return (
//     <MuiShowInferencer
//       fieldTransformer={(field: any) => {
//         if (["locale", "updatedAt", "publishedAt"].includes(field.key)) {
//           return false;
//         }

//         return field;
//       }}
//     />
//   );
// };

import { Stack, Typography } from "@mui/material";
import { useShow, useTranslation } from "@refinedev/core";
import {
  DateField,
  Show,
  TextFieldComponent as TextField,
} from "@refinedev/mui";
import TransactionsTable from "components/actions/Transactions";

export const ClientShow = () => {
  const { translate } = useTranslation();
  const { queryResult } = useShow({
    meta: {},
  });
  const { data, isLoading } = queryResult;

  const record = data?.data;

  return (
    <Show isLoading={isLoading}>
      <Stack gap={1}>
        <Typography variant="body1" fontWeight="bold">
          {translate("name")}
        </Typography>
        <TextField value={record?.name} />
        <Typography variant="body1" fontWeight="bold">
          {translate("phone")}
        </Typography>
        <TextField value={record?.phone ? "(+216) " + record?.phone : ""} />
        {record?.address?.length > 0 && (
          <>
            <Typography variant="body1" fontWeight="bold">
              {translate("Address")}
            </Typography>
            <TextField value={record?.address} />
          </>
        )}
        <Typography variant="body1" fontWeight="bold">
          {translate("posts.fields.createdAt")}
        </Typography>
        <DateField value={record?.createdAt} />
      </Stack>
      <TransactionsTable transactions={record?.actions || []} />
    </Show>
  );
};
